import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { STEPS } from "./data";
import { Eyebrow, MaskLines, Reveal } from "./motion";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const scale = useSpring(scrollYProgress, { stiffness: 80, damping: 25 });

  return (
    <section id="process" ref={ref} className="relative py-24 md:py-36 bg-slate-panel border-y border-white/10" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Eyebrow>How it works</Eyebrow>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1]">
          <MaskLines lines={["From survey", <span className="font-serif-i font-normal text-cyan-300">to support.</span>]} />
        </h2>
        <div className="relative mt-14 md:mt-20">
          <div className="absolute left-0 right-0 top-[7px] h-px bg-white/10 hidden md:block" />
          <motion.div className="absolute left-0 right-0 top-[7px] h-px bg-cyan-300 origin-left hidden md:block shadow-[0_0_12px_#00F0FF]" style={{ scaleX: scale }} />
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10 md:hidden" aria-hidden />
          <motion.div className="absolute left-[7px] top-2 bottom-2 w-px bg-cyan-300 origin-top md:hidden shadow-[0_0_12px_#00F0FF]" style={{ scaleY: scale }} aria-hidden />
          <div className="grid md:grid-cols-4 gap-12 md:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.12}>
                <div data-testid={`process-step-${s.n}`} className="relative pl-10 md:pl-0">
                  <span className="absolute left-0 top-1 md:relative md:top-0 block h-[15px] w-[15px] rounded-full border border-cyan-300 bg-void">
                    <span className="absolute inset-[3px] rounded-full bg-cyan-300" />
                    <span className="absolute -inset-1.5 rounded-full border border-cyan-300/40 animate-ping md:hidden" />
                  </span>
                  <p className="md:mt-8 font-mono text-[11px] tracking-[0.25em] text-slate-500">PHASE {s.n}</p>
                  <h3 className="mt-3 font-display text-3xl font-semibold">{s.title}</h3>
                  <p className="mt-4 text-slate-400 leading-relaxed">{s.body}</p>
                  <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-emerald-400/90">→ {s.out}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
